import * as React from 'react'

import * as style from './warning-icon.module.scss'

type Props = {
  addClass?: string
}

export default function WarningIcon(props: Props): React.ReactElement {
  const addClass = props.addClass !== null && props.addClass !== undefined ? props.addClass : ''

  return <i className={`fa fa-warning ${style.warningIcon} ${addClass}`} />
}
